export default __webpack_public_path__ + "static/media/checkLogo.abf9bf9e.png";